import translations from '../common/constants/translations';

export function translate( term ){
    return translations[term];
}
